import React, { useState,useCallback,useEffect } from 'react';
//import Modal from 'react-modal';
import Four from './Four';
import Voice from './Voice';
import Result from './Result';
//import Inc from './Include';
import './Main.scss';

let uid = null;
let name = null;
let resultHistory = null;
let resultKey = null;

function Main ({inputResultKey}){
	let defaultPage = "four";
	if( inputResultKey ){
		defaultPage = "result";
		if(!resultKey){
			resultKey = inputResultKey;
		}
	}

	const storage_key = "icqoo-retro-ink";
	const [page,setPage] = useState(defaultPage);
	const [face,setFace] = useState(0);
	//const [modalIsOpen,setModalIsOpen] = useState(false);
	//const [modalPage,setModalPage] = useState(null);

	let api_url = "";
	if( process.env.REACT_APP_RUNMODE==="PROD" ){
		api_url = "https://goisagi.retro-ink.com/beeapi/yellow/v1/";
	} else {
		api_url = "http://localhost:8080/beeapi/yellow/v1/";
	}

	const openVoice = useCallback(()=>{
		//console.log("open voice");
		//openModal("voice");
		setPage("voice");
	},[]);
	//const openModal = useCallback((page)=>{
	//	setModalIsOpen(true);
	//	setModalPage(page);
	//},[]);
	const setUser = useCallback((new_uid,new_name)=>{
		uid = new_uid;
		name = new_name;
		save();
	},[]);
	const save= ()=>{
		const json = {
			"uid": uid,
			"name": name,
		};
		window.localStorage.setItem(storage_key,JSON.stringify(json));
	};
	const load=()=>{
		if( window.localStorage.getItem(storage_key) ){
			const json = JSON.parse(window.localStorage.getItem(storage_key));
			//console.log(json);
			if( json.uid ){
				uid = json.uid;
				name = json.name;
				return true;
			}
		}
		ajax("uid/new",{},(res)=>{
			if( res.ok ){
				setUser(res.uid,"");
				//uid = res.uid;
				//save();
			}
		});
		return false;
	};
	const ajax = useCallback(( path , data , func )=>{
		const headers = new Headers()
		headers.append("Content-Type", 'application/json')
			
		const corsOptions = {}
		var options = { headers }
		options = { ...corsOptions, method:'POST',body:JSON.stringify( data ) };

		//console.log( this.api_url+path );
		//console.log( options );

		fetch(api_url+path, options).then( res=> {
			//console.log("then1");
			//console.log( res );
			try{
				if( res.status===200 ){
					return res.json();
				} else {
					error();
				}
			} catch(err) {
				error();
			}
		}).then( (json)=>{
			//console.log("then2");
			//console.log( json );
			func( json );
		}).catch( (err)=>{
			//console.log("catch");
			//console.log(err);
			error();
		})
	},[]);
	const error = useCallback(()=>{
		//console.log("error");
		alert("ネットワークエラーが発生しました。処理を中断します。");
	},[]);
	const close = useCallback(()=>{
		newFace();
		setPage("four");
	});
	const newFace = useCallback(()=>{
		setFace(Math.floor(Math.random()*4)+1);
	});

	const click = (num)=>{
		//console.log(num);
		if( face===num ){
			openVoice();
		}
	};
	const goResult = (key,history)=>{
		//console.log("go result");
		resultKey = key;
		if( history ){
			resultHistory = history;
		} else {
			resultHistory = null;
		}
		setPage("result");
	}
	const config = ()=>{
		ajax("config",{},()=>{
			console.log("config");
		});
	}
	load();

	useEffect( ()=>{
		newFace();
	},[]);

	let configclass = "config";
	if( process.env.REACT_APP_RUNMODE!=="DEV" ){
		configclass += " hide";
	}
	//console.log("render main");
	return (
		<div id="main">
			{page==='four' &&
			<Four notice={face} click={click}/>
			}
			{page==='voice' &&
			<Voice uid={uid} face={face} close={close} ajax={ajax} goResult={goResult}/>
			}
			{page==='result' &&
			<Result ajax={ajax} defaultFace={face} resultKey={resultKey} resultHistory={resultHistory} close={close}/>
			}
			<div className={configclass}>
				<button
					onClick={config}
				>初期設定</button>
			</div>
		</div>
	);
}

export default Main;
